import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import {
    useAuthenticateMutation,
    useCreateLoginLinkMutation, useCreateResetPasswordLinkMutation,
    useForgotPasswordMutation,
    useLazyPreauthQuery
} from "../slices/apiSlice";
import {useNavigate} from "react-router-dom";
import {
    Alert,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Slide,
    Snackbar
} from "@mui/material";
import {useEffect} from "react";

const MODE_AUTHENTICATE = 0x01
const MODE_EMAIL = 0x11
const MODE_CHOOSE_USERNAME = 0x12
const MODE_PASSWORD = 0x13


export default function Login({
                                  modal,
                                  headerText = 'Sign in',
                                  actionText = 'Sign in',
                                  initMode = MODE_AUTHENTICATE,
                                  cause,
                                  prefillEmail,
                                  showRedressPaths = true,
                                  forgotPasswordAction,

}) {

    const navigate = useNavigate()

    const [ username, setUsername] = React.useState()
    const [ usernames, setUsernames] = React.useState([])
    const [ mode, setMode ] = React.useState (initMode)
    const [ successSnackOpen, setSuccessSnackOpen] = React.useState(false)
    const [ warningSnackOpen, setWarningSnackOpen] = React.useState(false)
    const [ warningSnackMessage, setWarningSnackMessage ] = React.useState ()
    const [ emailRequestDialogOpen, setEmailRequestDialogOpen] = React.useState(false)
    const [ reminderEmailSent, setReminderEmailSent] = React.useState(false)

    let open=true


    const [authenticate, { isLoading, isError: hasAuthenticationError, error, isSuccess: hasAuthenticated }] =
        useAuthenticateMutation()

    const [preauth, preauthResult]  =
        useLazyPreauthQuery()

    const [createLoginLink, createLoginLinkResult] =
        useCreateLoginLinkMutation()

    const [createPasswordResetLink, createPasswordResetLinkResult] =
        useCreateResetPasswordLinkMutation()

    const isEmail = (txt) => {
        return String(txt)
            .toLowerCase()
            .match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
    }

    const handleSubmit = (event) => {
        event.preventDefault()

        const data = new FormData(event.currentTarget);

        if (mode === MODE_AUTHENTICATE ) {
            authenticate({
                username: data.get('username'),
                password: data.get('password'),
            })
        }
        else if (mode === MODE_EMAIL) {
            preauth({email:data.get('email')})
        }
        else if (mode === MODE_CHOOSE_USERNAME) {
            setUsername(data.get('email'))
            //TODO this is for texting
            setMode(MODE_PASSWORD)
        }
    }

    const handleForgotPassword = (e) => {
        if (!reminderEmailSent) {
            if (prefillEmail) {
                if (forgotPasswordAction) {
                    createLoginLink({username: prefillEmail, action: forgotPasswordAction})
                }
                else {
                    createPasswordResetLink({username: prefillEmail})
                }
            }
            else {
                setEmailRequestDialogOpen(true)
            }
        }
    }

    const handleSuccessSnackClose = () => {
        setSuccessSnackOpen(false)
    }

    const handleWarningSnackClose = () => {
        setWarningSnackOpen(false)
    }

    const handleEmailReguestDialogClose = () => {
        setEmailRequestDialogOpen(false)
    }

    const handleEmailReguestDialogSubmit = (e) => {
        e.preventDefault()
        handleEmailReguestDialogClose()

        const formData = new FormData(e.currentTarget)
        const email= formData.get('email')
        if (email.length>3) {
            if (forgotPasswordAction) {
                createLoginLink({username: email, action: forgotPasswordAction})
            }
            else {
                createPasswordResetLink({username: email})
            }
        }
    }

    const handleUsernameClick = (username) => {
        setUsername(username)
        setMode(MODE_PASSWORD)
    }

    if (hasAuthenticated) {
        if (modal) open=false
    }

    useEffect(()=>{
        if (preauthResult.isSuccess) {
            const un = preauthResult.data.usernames
            setUsernames(un)
            if (un && un.length > 1 ) {
                setMode(MODE_CHOOSE_USERNAME)
            }
            else if (un && un.length === 1) {
                setMode(MODE_PASSWORD)
            }
            else {
                //TODO: redirect to create account
                console.log('No account for this email')
            }
        }
    },[preauthResult])

    useEffect(()=>{
        if (createLoginLinkResult.isSuccess && createLoginLinkResult.data.status === 'ok'){
            setSuccessSnackOpen(true)
            setReminderEmailSent(true)
        }
        else if (createPasswordResetLinkResult.isSuccess && createPasswordResetLinkResult.data.status === 'ok'){
            setSuccessSnackOpen(true)
            setReminderEmailSent(true)
        }
        else if (createLoginLinkResult.isSuccess && createLoginLinkResult.data.status === 'error') {
            console.log("*** Error while creating login link")
            console.log(createLoginLinkResult.data.error)
        }
        else if (createPasswordResetLinkResult.isSuccess && createPasswordResetLinkResult.data.status === 'error') {
            console.log("*** Error while creating login link")
            console.log(createPasswordResetLinkResult.data.error)
        }
        else if (createLoginLinkResult.error) {
            console.log("*** Error while creating login link")
            console.log(createLoginLinkResult.error)
        }
        else if (createPasswordResetLinkResult.error) {
            console.log("*** Error while creating login link")
            console.log(createPasswordResetLinkResult.error)
        }
    },[createLoginLinkResult, createPasswordResetLinkResult])

    const components =(
        <Container component="main" maxWidth="xs" sx={{margin: modal ? '2em 1em' : ''}}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                {modal &&
                    <Box sx={{marginBottom: '1em'}}>
                        <Link href={'/'}>
                            <img src='/etc/img/cc-stadium-logo-black.png' style={{width: '12em'}}/>
                        </Link>
                    </Box>
                }
                { headerText &&
                    <Typography component="h1" variant="h5">
                        {headerText}
                    </Typography>
                }
                {cause && cause === 'registerExistingAccount' &&
                    <Box my={2}>
                        <Alert severity={'warning'} my={2} sx={{textAlign:'left'}}>
                            <Typography variant={'body2'} mb={1}>
                                The email account you have provided is already registered with Crosscountry.
                            </Typography>
                            <Typography variant={'body2'}>
                                Please sign in to proceed.
                            </Typography>
                        </Alert>
                    </Box>
                }
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                    { mode === MODE_AUTHENTICATE &&
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="username"
                        label="Email or Username"
                        name="username"
                        autoComplete="username"
                        defaultValue={prefillEmail ? prefillEmail : ''}
                        autoFocus
                    />
                    }
                    { mode === MODE_EMAIL &&
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="email"
                            name="email"
                            autoComplete="email"
                            autoFocus
                        />
                    }
                    { mode === MODE_PASSWORD &&
                        <TextField
                            margin="normal"
                            fullWidth
                            id="username"
                            name="username"
                            label="Username"
                            value={username}
                            disabled
                        />
                    }
                    { (mode === MODE_AUTHENTICATE || mode === MODE_PASSWORD) &&
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                    />
                    }
                    { mode === MODE_CHOOSE_USERNAME &&
                        <Box sx={{
                            minWidth: '250px',
                        }}>
                            {
                                usernames.map( u => {
                                    return <Box
                                        onClick = {() => {handleUsernameClick(u)}}
                                        sx={{
                                            p: '.5em 1em',
                                            my: '1em',
                                            background: '#eeeeee',
                                            '&:hover': {
                                                background: "#dddddd",
                                            },
                                            borderRadius : '5px',
                                    }}>
                                        {u}
                                    </Box>
                                })
                            }
                        </Box>
                    }
                    { false && mode === MODE_AUTHENTICATE &&
                    <FormControlLabel
                        control={<Checkbox value="remember" color="primary" />}
                        label="Remember me"
                    />
                    }
                    { mode !== MODE_CHOOSE_USERNAME &&
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            {actionText}
                        </Button>
                    }
                    {hasAuthenticationError &&
                        <Alert severity="error" sx={{margin: '0.5em 0 1em 0'}}>Incorrect username or password.
                            Please try again</Alert>
                    }
                    {cause && cause === 'registerExistingAccount' &&
                        <Typography variant={'body2'} component={'div'} pb={2} sx={{textAlign:'left'}}>
                            If you do not remember your login details please click&nbsp;
                            <Link href={"#"} onClick={handleForgotPassword}>here</Link>
                        </Typography>
                    }
                    { !(cause && cause === 'registerExistingAccount') && (mode === MODE_AUTHENTICATE || mode === MODE_PASSWORD) &&
                    <Grid container spacing={2}>
                        <Grid item xs sx={{textAlign:'left'}}>
                            <Link href={"#"} onClick={handleForgotPassword} variant="body2">
                                Forgot password?
                            </Link>
                        </Grid>
                        {showRedressPaths &&
                            <Grid item>
                            <Link href="/register" variant="body2">
                                {"Don't have an account? Register now"}
                            </Link>
                        </Grid>
                        }
                    </Grid>
                    }
                </Box>
            </Box>
            <Snackbar
                open={successSnackOpen}
                onClose={handleSuccessSnackClose}
                severity={'success'}
                TransitionComponent={(props) => <Slide {...props} direction="down" />}
                key={'sentReminderEmail'}
            >
                <Alert onClose={handleSuccessSnackClose} severity="success" sx={{ width: '100%' }}>
                    We've sent a sign-in link to your email.
                    Simply click on it to access your account.<br/>
                    If you can't find the email, please check your spam folder.                </Alert>
            </Snackbar>
            <Snackbar
                open={warningSnackOpen}
                onClose={handleWarningSnackClose}
                severity={'warning'}
                TransitionComponent={(props) => <Slide {...props} direction="down" />}
                key={'warningReminderEmail'}
            >
                <Alert onClose={handleSuccessSnackClose} severity="warning" sx={{ width: '100%' }}>
                    {warningSnackMessage}
                </Alert>
            </Snackbar>
            <Dialog open={emailRequestDialogOpen} onClose={handleEmailReguestDialogClose}  component={'form'} onSubmit={handleEmailReguestDialogSubmit}>
                <DialogTitle>Access your account</DialogTitle>
                <DialogContent>
                    <DialogContentText mb={1}>
                        Please provide the username or email address
                        the account was registered with:
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Email or Username"
                        name="email"
                        fullWidth
                        variant="standard"
                    />
                    <DialogContentText my={2}>
                        A link to access your account will be sent to your email
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleEmailReguestDialogClose}>Cancel</Button>
                    <Button type="submit">Send link</Button>
                </DialogActions>
            </Dialog>
        </Container>
    )

    return (

            modal ?
                <Dialog open={open}>
                    {components}
                </Dialog>
                :
                components
    );
}